import styled from '@emotion/styled';
import { Divider } from 'antd';
import React from 'react';

interface IndexColumnProps {
  value: number;
  className?: string;
}

export default React.memo((props: IndexColumnProps) => {
  return (
    <StyledIndexColumnContent className={props?.className || ''}>
      <div className="d-flex align-items-center justify-content-center">
        <b style={{ marginLeft: '5px' }}>{props.value + 1}</b>
      </div>
      <Divider type="vertical" />
    </StyledIndexColumnContent>
  );
});

const StyledIndexColumnContent = styled.div`
  .ant-divider {
    position: absolute;
    right: -0.5rem;
    height: calc(100% - 1rem);
    top: 0.5rem;
    border-left-width: 2px;
  }
`;
